import { render, staticRenderFns } from "./FaqDetail.vue?vue&type=template&id=a6964fd6&scoped=true"
import script from "./FaqDetail.vue?vue&type=script&lang=js"
export * from "./FaqDetail.vue?vue&type=script&lang=js"
import style0 from "./FaqDetail.vue?vue&type=style&index=0&id=a6964fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6964fd6",
  null
  
)

export default component.exports